module.exports = __webpack_public_path__ + "static/media/group--freezing-temperatures.38609382.svg";